module.exports = __webpack_public_path__ + "img/bannerN6.c562b801.png";